document.addEventListener('DOMContentLoaded', () => {
  const { analytics, segment_data: segmentData } = window;

  if (!analytics) {
    return;
  }

  /**
   * Segment track for single pathway accordion clicks.
   */
  const trackPathwayAccordionClicks = () => {
    if (segmentData?.postType !== 'career_pathway') {
      return;
    }
    const accordionItems = document.querySelectorAll('.wp-block-bigbite-accordion-item');
    if (!accordionItems) {
      return;
    }
    accordionItems.forEach((accordion) => {
      accordion.addEventListener('click', () => {
        if (!accordion.classList.contains('is-closed')) {
          return;
        }
        const accordionItem = accordion.querySelector('.bbAccordion_summary-summaryText').innerText;
        analytics.track('edx.bi.crc.pathway-accordion-item.click', {
          pathway: segmentData?.postTitle,
          accordionItem,
        });
      });
    });
  };

  /**
   * Function to contain homepage hero link tracking instances
   */
  const trackHomepageHeroLinks = () => {
    // Segment track for career path homepage hero link
    const careerPathHero = document.querySelector(
      '.wp-block-cen-marketing-crc-homepage-hero .crc-homepage-hero__mainSectionContainerLeft .crc-homepage-hero__mainTitleContainer > a',
    );
    if (careerPathHero) {
      careerPathHero.addEventListener('click', () => {
        analytics.track('edx.bi.crc.career-path-hero.click', {});
      });
    }

    // Segment track for job resources homepage hero link
    const jobResourceHero = document.querySelector(
      '.wp-block-cen-marketing-crc-homepage-hero .crc-homepage-hero__mainSectionContainerRight .crc-homepage-hero__mainTitleContainer > a',
    );
    if (jobResourceHero) {
      jobResourceHero.addEventListener('click', () => {
        analytics.track('edx.bi.crc.job-resource-hero.click', {});
      });
    }
  };

  /**
   * Segment track for article card click.
   */
  const trackArticleCardClick = () => {
    const articleCard = document.querySelectorAll(
      '.cen-post-card--article.wp-block-bigbite-post-card',
    );
    if (!articleCard) {
      return;
    }
    articleCard.forEach((card) => {
      card.addEventListener('click', () => {
        const cardTitle = card.querySelector('.wp-block-post-title').innerText;
        analytics.track('edx.bi.crc.article-card.click', {
          cardTitle,
        });
      });
    });
  };

  /**
   * Segment track for industry post cards
   */
  const trackIndustryCardClicks = () => {
    if (segmentData?.urlPath !== '/browse-by-industry/') {
      return;
    }
    const industryCard = document.querySelectorAll('.wp-block-bigbite-post-card');

    if (!industryCard) {
      return;
    }

    industryCard.forEach((card) => {
      card.addEventListener('click', () => {
        const cardTitle = card.querySelector('.card-content h3').innerText;
        analytics.track('edx.bi.crc.industry-card.click', {
          cardTitle,
        });
      });
    });
  };

  /**
   * Segment track for navigation menu clicks
   */
  const trackMainNavClicks = () => {
    const mainNavMenuLinks = document.querySelectorAll('header nav ul.menu > li.menu-item > a');
    if (!mainNavMenuLinks) {
      return;
    }
    mainNavMenuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        analytics.track('edx.bi.crc.navigation.click', {
          navigationItem: link.innerText,
        });
      });
    });
  };

  /**
   * Segment track for navigation menu clicks
   */
  const trackIndustryBrowseClicks = () => {
    const browseByIndustryMenuLinks = document.querySelectorAll(
      'header nav ul.menu > li.browse-by-industry li.menu-item > a',
    );

    if (!browseByIndustryMenuLinks) {
      return;
    }
    browseByIndustryMenuLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        analytics.track('edx.bi.crc.industry-menu-item.click', {
          industryItem: link.innerText,
        });
        // prevents further nav click call being made
        e.stopPropagation();
      });
    });
  };

  /**
   * Segment track for a course card click event.
   */
  const trackCourseCardClicks = () => {
    const courseCard = document.querySelectorAll('.featured-course-card');

    if (!courseCard) {
      return;
    }

    courseCard.forEach((card) => {
      card.addEventListener('click', () => {
        const courseTitle = card.querySelector('.featured-course-card__title').innerText;
        const institution = card.querySelector('.featured-course-card__sub').innerText;
        const courseId = card?.dataset?.courseId;
        const courseUuid = card?.dataset?.courseUuid;
        const label = card?.dataset?.label;

        // eslint-disable-next-line no-undef
        analytics.track('edx.bi.crc.course-card.click', {
          course: courseTitle,
          institution,
          objectId: courseId,
          program_uuid: courseUuid,
          label,
        });
      });
    });
  };

  /**
   * Segment track to track scroll percentages on homepage and single career pathway pages
   */
  const trackScrollPercentage = () => {
    // declare these variables so that track only fires once per page load
    let is25 = true;
    let is50 = true;
    let is75 = true;
    let is100 = true;
    let postType = '';

    if (segmentData?.urlPath === '/') {
      postType = 'homepage';
    } else if (segmentData?.postType === 'career_pathway') {
      postType = 'career-pathway';
    } else return;

    document.addEventListener('scroll', () => {
      const scrollPercentage = Math.round(
        (window.scrollY /
          (document.documentElement.scrollHeight - document.documentElement.clientHeight)) *
          100,
      );

      /**
       * Function to contain segment call
       */
      const segmentTrackScrollPercentage = (percent) => {
        analytics.track(`edx.bi.crc.${postType}.scroll-percentage`, {
          trackScrollPercentage: percent,
        });
      };

      if (scrollPercentage >= 25 && is25) {
        segmentTrackScrollPercentage(25);
        is25 = false;
      }

      if (scrollPercentage >= 50 && is50) {
        segmentTrackScrollPercentage(50);
        is50 = false;
      }

      if (scrollPercentage >= 75 && is75) {
        segmentTrackScrollPercentage(75);
        is75 = false;
      }

      if (scrollPercentage === 100 && is100) {
        segmentTrackScrollPercentage(100);
        is100 = false;
      }
    });
  };

  /**
   * Segment track for pathway audio player clicks
   */
  const trackPathwayAudioPlayerClicks = () => {
    if (segmentData?.postType !== 'career_pathway') {
      return;
    }
    const audioPlayer = document.querySelectorAll('figure.wp-block-audio > audio');
    if (audioPlayer.length === 0) {
      return;
    }
    audioPlayer.forEach((player) => {
      player.addEventListener('play', () => {
        analytics.track('edx.bi.crc.pathway-audio-player.play', {
          pathway: segmentData?.postTitle,
        });
      });
    });
  };

  /**
   * Segment track for guides and templates links
   */
  const trackGuidesAndTemplateLinks = () => {
    if (segmentData?.urlPath !== '/guides-and-templates/') {
      return;
    }
    const generalResourceItem = document.querySelectorAll('article.wp-block-post.type-resource a');
    if (!generalResourceItem) {
      return;
    }
    generalResourceItem.forEach((item) => {
      if (item.closest('.bbAccordion_details-detailsWrapper article')) {
        item.addEventListener('click', () => {
          analytics.track('edx.bi.crc.guides-and-templates-industry-specific-item.click', {
            itemTitle: item.innerText,
          });
        });
      } else {
        item.addEventListener('click', () => {
          analytics.track('edx.bi.crc.guides-and-templates-general-resource-item.click', {
            itemTitle: item.innerText,
          });
        });
      }
    });
  };

  /**
   * Segment track for homepage hero buttons
   */
  const trackHomepageHeroButtons = () => {
    const hero = document.querySelector('.wp-block-cen-marketing-crc-homepage-hero');
    if (!hero) {
      return;
    }
    const careerPathButtons = hero.querySelectorAll(
      '.crc-homepage-hero__mainSectionContainerLeft .crc-homepage-hero__buttonGroup > a',
    );
    const jobResourcesButton = hero.querySelectorAll(
      '.crc-homepage-hero__mainSectionContainerRight .crc-homepage-hero__buttonGroup > a',
    );
    /**
     * Function to add event listeners to hero buttons
     */
    const addHeroButtonEventListeners = (buttons, eventName, propertyName) => {
      buttons?.forEach((button) => {
        button?.addEventListener('click', () => {
          analytics.track(eventName, {
            [propertyName]: button?.innerText,
          });
        });
      });
    };
    addHeroButtonEventListeners(
      careerPathButtons,
      'edx.bi.crc.homepage-hero-career.click',
      'careerPath',
    );
    addHeroButtonEventListeners(
      jobResourcesButton,
      'edx.bi.crc.homepage-hero-job.click',
      'buttonName',
    );
  };

  /**
   * Segment track for footer logo clicks
   */
  const trackFooterLogoClicks = () => {
    const footerLogo = document.querySelector('footer .edx-logo > a');

    if (!footerLogo) {
      return;
    }

    footerLogo.addEventListener('click', () => {
      analytics.track('edx.bi.crc.footer-logo.click', {});
    });
  };

  /**
   * Segment track for account dropdown options
   */
  const trackAccountDropdownClicks = () => {
    const accountDropdownLinks = document.querySelectorAll(
      '.site-header__main__site-account-dropdown ul > li a',
    );
    if (!accountDropdownLinks) {
      return;
    }
    accountDropdownLinks.forEach((link) => {
      link.addEventListener('click', () => {
        analytics.track(`edx.bi.crc.account-dropdown.click`, {
          DropdownItem: link?.innerText,
        });
      });
    });
  };

  /**
   * Segment track for show me [industry] courses button click event.
   */
  const trackShowMeCoursesButtonClicks = () => {
    if (segmentData?.postType !== 'career_pathway') {
      return;
    }

    const showMeCoursesButton = document.querySelectorAll(
      '.wp-block-post-content  a.wp-block-button__link.wp-element-button',
    );
    if (!showMeCoursesButton) {
      return;
    }
    showMeCoursesButton.forEach((button) => {
      if (!button.innerText.includes('Show me')) {
        return;
      }
      button.addEventListener('click', () => {
        analytics.track('edx.bi.crc.show-me-courses-button.click', {});
      });
    });
  };

  /**
   * Segment track for 'view all courses' link within course cards
   */
  const trackViewAllCoursesClick = () => {
    const viewAllCoursesLink = [...document.querySelectorAll('a')].filter(
      (link) =>
        link?.href?.includes('https://www.edx.org/search?tab=course&utm_source=crc') &&
        link?.innerText?.toLowerCase().includes('see all'),
    );
    if (viewAllCoursesLink?.length === 0) {
      return;
    }
    viewAllCoursesLink.forEach((link) => {
      link.addEventListener('click', () => {
        analytics.track('edx.bi.crc.course-card-view-all-courses.click', {});
      });
    });
  };

  /**
   * Segment page for an individual event
   */
  const trackIndividualEventPage = () => {
    if (segmentData?.postType === 'event') {
      analytics.track('edx.bi.crc.events.view.individual-event', {
        eventName: segmentData.postTitle,
        eventDate: segmentData.eventDate,
      });
    }
  };

  trackIndustryCardClicks();
  trackMainNavClicks();
  trackIndustryBrowseClicks();
  trackCourseCardClicks();
  trackViewAllCoursesClick();
  trackIndividualEventPage();
  trackPathwayAccordionClicks();
  trackPathwayAudioPlayerClicks();
  trackGuidesAndTemplateLinks();
  trackHomepageHeroButtons();
  trackHomepageHeroLinks();
  trackFooterLogoClicks();
  trackAccountDropdownClicks();
  trackShowMeCoursesButtonClicks();
  trackArticleCardClick();
  trackScrollPercentage();
});
